import { useAtom } from "jotai";
import { useEffect } from "react";
import { PogSummaryModalInner } from "./PogSummaryModal";
import { pogSummaryModalDataAtom } from "./store/atoms";

export const PogSummaryModal = () => {
  const [data, setData] = useAtom(pogSummaryModalDataAtom);

  useEffect(() => {
    return () => {
      setData(null);
    };
  }, [setData]);

  if (!data) return null;

  return <PogSummaryModalInner pogSummaryData={data} />;
};

export default PogSummaryModal;
